import MarksInfo from "./MarksInfo";
import CourseInfo from "./CourseInfo";
import CourseImage from "./CourseImage";


const SalRaceInfo = ({ data }) => {

    return (
        <div className="container">
            <div className="row">
                <div className="w-65"><MarksInfo data={data} /></div>
                <div className="w-25"><CourseInfo data={data} /></div>
                <div className="w-10"><CourseImage data={data} /></div>
            </div>
        </div>
    );
}

export default SalRaceInfo;